import * as React from "react";
import styled, { css } from "styled-components";

import { Metrics, ToolbarItemPropTypes } from "../../vars";

const propTypes = {
  ...ToolbarItemPropTypes,
};

const ToolbarButton: React.FC<any> = ({
  children,
  icon,
  href,
  ...otherProps
}) => (
  <a href={href} {...otherProps}>
    {icon && <i className="md-icon">{icon}</i>}
    <span>{children}</span>
  </a>
);

ToolbarButton.propTypes = propTypes;

export default styled(ToolbarButton)`
  font-size: ${Metrics.FontSizes.TOOLBAR_ITEM_TEXT}px;
  line-height: ${Metrics.LineHeights.TOOLBAR_ITEM_TEXT}px;
  padding: ${Metrics.Padding.TOOLBAR_ITEM_Y}px
    ${Metrics.Padding.TOOLBAR_ITEM_X}px;
  color: ${(p) => p.theme.colors.grey400};
  text-decoration: none;
  border-left: 1px solid ${(p) => p.theme.colors.grey200};

  .style--rebrand & {
    text-decoration: none;

    i {
      color: ${(p) => p.theme.colors.grey300};
    }

    ${(props) =>
      props.active &&
      css`
        span {
          border-bottom: 2px solid ${(p) => p.theme.colors.secondary};
          padding-bottom: 1px;
        }
      `};
  }

  .style--rebrand &:hover {
    text-decoration: none;
    color: ${(p) => p.theme.colors.primary};

    i {
      color: ${(p) => p.theme.colors.primary};
    }
  }
`;
